import { appEnv } from 'src/config'
import Model from 'src/models/model'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const rollbar = {}

  rollbar.critical = function () {
    console.error.apply(console, arguments)

    if (typeof Rollbar === 'undefined') return

    // eslint-disable-next-line no-undef
    Rollbar.critical.apply(Rollbar, arguments)
  }

  rollbar.error = function () {
    console.error.apply(console, arguments)

    if (typeof Rollbar === 'undefined') return

    // eslint-disable-next-line no-undef
    Rollbar.error.apply(Rollbar, arguments)
  }

  rollbar.warning = function () {
    console.warn.apply(console, arguments)

    if (typeof Rollbar === 'undefined') return

    // eslint-disable-next-line no-undef
    Rollbar.warning.apply(Rollbar, arguments)
  }

  rollbar.info = function () {
    if (typeof Rollbar === 'undefined') return

    // eslint-disable-next-line no-undef
    Rollbar.info.apply(Rollbar, arguments)
  }

  app.config.globalProperties.$rollbar = rollbar
  Model.prototype.$rollbar = rollbar

  app.config.errorHandler = (err, vm) => {
    if (vm.$rollbar && vm.$rollbar.error) {
      vm.$rollbar.error(err)
    }

    if (appEnv === 'production') {
      console.error(err)
    } else {
      throw err
    }
  }
}
